import {
	useCallback,
	useEffect,
	useState
} from "react"
import { EmblaCarouselType } from "embla-carousel"

type UseDotButtonType = {
	selectedIndex: number
	scrollSnaps: number[]
	onDotButtonClick: (index: number) => void
}

export const useDotButton = (
	emblaApi: EmblaCarouselType | undefined
): UseDotButtonType => {
	const [selectedIndex, setSelectedIndex] = useState(0)
	const [scrollSnaps, setScrollSnaps] = useState<number[]>([])

	const onDotButtonClick = useCallback(
		(index: number) => {
			if (!emblaApi) return
			emblaApi.scrollTo(index)
		},
		[emblaApi]
	)

	const initializeCarouselScrollSnaps = useCallback((emblaApi: EmblaCarouselType) => {
		setScrollSnaps(emblaApi.scrollSnapList())
	}, [])

	const updateSelectedIndexOnCarouselSelect = useCallback((emblaApi: EmblaCarouselType) => {
		setSelectedIndex(emblaApi.selectedScrollSnap())
	}, [])

	useEffect(() => {
		if (!emblaApi) return

		initializeCarouselScrollSnaps(emblaApi)
		updateSelectedIndexOnCarouselSelect(emblaApi)
		emblaApi.on("reInit", initializeCarouselScrollSnaps).on("reInit", updateSelectedIndexOnCarouselSelect).on("select", updateSelectedIndexOnCarouselSelect)
	}, [emblaApi, initializeCarouselScrollSnaps, updateSelectedIndexOnCarouselSelect])

	return {
		selectedIndex,
		scrollSnaps,
		onDotButtonClick
	}
}
